import React from 'react';
import styled from 'styled-components';

const BannerStyled = styled.div<{ notification: boolean }>`
  width: 17px;
  height: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: ${(props) => props.theme.colors.error500};
  position: absolute;
  right: ${({ notification }) => (notification ? '18px' : '12px')};
  top: ${({ notification }) => (notification ? '-1px' : '-6px')};
  color: ${({ theme }) => theme.colors.neutral900};
`;

const Banner = ({
  unseen,
  notification
}: {
  unseen: number;
  notification: boolean;
}) => {
  return (
    <>
      {unseen > 0 ? (
        <BannerStyled notification={notification}></BannerStyled>
      ) : (
        <></>
      )}
    </>
  );
};

export default Banner;
